const deriveGradientBaseColorFromGradientModel = (gradientModel) => {
  const [h, s, l] = gradientModel?.colorStops?.[0]?.value?.map(Number) || [];

  if (Number.isFinite(h) && Number.isFinite(s) && Number.isFinite(l)) {
    return { h, s, l, a: 1 };
  }

  return null;
};

export default deriveGradientBaseColorFromGradientModel;
